import { Cacheable, CacheBuster } from 'ts-cacheable';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ProgramCategoryList } from 'src/app/program/model/programCategoryList';
import { ProgramCategoryEdit } from 'src/app/program/model/programCategoryEdit';

const programCategoriesCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class ProgramCategoryService
{
  constructor(private http: HttpClient) { }

  /**
   * Get full Program Categories object.
   */
  @Cacheable(
    {
      cacheBusterObserver: programCategoriesCacheBuster
    })
  public getCachedProgramCategories(activeOnly = false): Observable<ProgramCategoryList[]>
  {
    return this.http.get<ProgramCategoryList[]>('/programs/categories?activeonly=' + activeOnly);
  }

  /**
   * Delete a Program Category.
   *
   * @param id Program Cateogry id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: programCategoriesCacheBuster
    })
  public deleteProgramCategory(id: number): Observable<ProgramCategoryList>
  {
    return this.http.delete<ProgramCategoryList>(`/programs/category/${id}`);
  }

  /**
   * Save a Program Category.
   *
   * @param data Program Category to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: programCategoriesCacheBuster
    })
  public saveProgramCategory(data: any, isNew: boolean, programCategoryId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/programs/category', data);
    }
    else
    {
      return this.http.put(`/programs/category/${programCategoryId}`, data);
    }
  }

  /**
   * Get Program Categories for grid list.
   */
  public getProgramCategoriesList(): Observable<ProgramCategoryList[]>
  {
    return this.http.get<ProgramCategoryList[]>('/programs/categories/list');
  }

  /**
   * Get full Program Categories object.
   */
  public getProgramCategories(activeOnly = false): Observable<ProgramCategoryList[]>
  {
    return this.http.get<ProgramCategoryList[]>(`/programs/categories?activeonly=${activeOnly}`);
  }

  /**
   * Get Program Category by id.
   *
   * @param id Program Category id
   */
  public getProgramCategoryById(id: number): Observable<ProgramCategoryEdit>
  {
    return this.http.get<ProgramCategoryEdit>(`/programs/category/${id}`);
  }

  /**
   * Check if Program Category is in use
   *
   * @param id Program Category Id
   */
  public existsProgramCategory(id: number): Observable<any>
  {
    return this.http.get(`/programs/category/inuse/${id}`);
  }

  /**
   * Check if Program Category Name exists to avoid name duplicates
   *
   * @param name Program Category Name
   */
  public existsProgramCategoryName(name: string): Observable<any>
  {
    return this.http.get(`/programs/category/exists?name=${name}`);
  }
}
